import { useState, useEffect } from 'react';
import { api } from '../api/client';

interface User {
  id: number;
  messenger_id: string;
  role: 'owner' | 'admin' | 'tech' | 'client';
  full_name: string;
  username: string;
}

export function useUser() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api.get('/me');
        setUser(response.data);
      } catch (err) {
        setError('Не удалось получить информацию о пользователе');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return { user, loading, error };
}